// Mesa de ayuda (GLPI): solo algunos ambientes la tienen. Se activa con
// VUE_APP_HELPDESK_ENABLED=true en env.js (equivale a HELPDESK_ENABLED en el back).
export const isHelpdeskEnabled = () => {
  const value = window.__env && window.__env.VUE_APP_HELPDESK_ENABLED
  return value === true || String(value).toLowerCase() === 'true'
}

// Quita del menú el grupo de mesa de ayuda cuando el ambiente no la tiene
export const withoutHelpdeskMenu = items => (items || [])
  .filter(item => item.title !== 'helpdesk.title')
  .map(item => (item.children ? { ...item, children: withoutHelpdeskMenu(item.children) } : item))
